import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import RoleService from "services/RoleService";
import { SnackbarContext } from "context/snackBarContext";

const PendingVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.rowData;
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const handleSendBack = async () => {
    try {
      await RoleService.updateAssignmentStatus({
        roleId: rowData.profileId,
        assignmentStatus: "Pending",
        serviceNumber: rowData.serviceNumber
      });
      
      setMessage("Successfully sent back to role owner");
      setSeverity("success");
      setOpenAlert(true);
      navigate("/roleCreation");
    } catch (error) {
      setMessage("Failed to update status");
      setSeverity("error");
      setOpenAlert(true);
    }
  };

  
  const handleVerified = async () => {
    navigate("/sr-number-input", { state: { rowData } });
  };

const handleWarningClose = () => {
    setOpenWarning(false);
  };

  const handleWarningConfirm = () => {
    setOpenWarning(false);
    navigate("/sr-number-input", { state: { rowData } });
  };
    const [openWarning, setOpenWarning] = React.useState(false);

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f0f3f6",
                    height: "80vh",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                    borderRadius: "6px"
                  }}
                >
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        padding: 5,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 3px 8px',
      }}>
        <Button
          onClick={handleSendBack}
          sx={{
            width: '300px',
            backgroundColor: '#6C7B8A',
            color: 'white',
            '&:hover': {
              backgroundColor: '#5A6978'
            },
            padding: '12px',
            borderRadius: '4px',
            textTransform: 'none',
            fontSize: '16px'
          }}
        >
          SEND BACK TO ROLE OWNER
        </Button>
        <Button
          onClick={handleVerified}
          sx={{
            width: '300px',
            backgroundColor: '#50AF47',
            color: 'white',
            '&:hover': {
              backgroundColor: '#3F9B37'
            },
            padding: '12px',
            borderRadius: '4px',
            textTransform: 'none',
            fontSize: '16px'
          }}
        >
          VERIFIED
        </Button>
      </Box>
      </Box>
      </Box>

      <Dialog
        open={openWarning}
        onClose={handleWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Warning"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you really want to send back to role Owner?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleWarningClose}
            sx={{
              color: '#6C7B8A',
            }}
          >
            No
          </Button>
          <Button 
            onClick={handleWarningConfirm}
            sx={{
              color: '#0A3575',
            }}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </LayoutAccessManagement>
  );
};

export default PendingVerification;
